module.exports = __webpack_public_path__ + "static/header1-f45a2547f469a1c101e81443707ba7a6.jpeg";